// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].use[1]!../../../node_modules/@jetbrains/ring-ui/components/global/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableWrapper__ea9 {
  display: flex;
  flex-direction: column;
  gap: var(--ring-unit);
  padding-bottom: calc(var(--ring-unit) * 3);
}

/*
Apply negative margins to let table take the full width.
It's assumed that table is the first child of the tableWrapper.
Actually table is wrapped by div by default so we have to apply styles to the div element.
*/
.tableWrapper__ea9 > div:nth-child(1) {
  margin: calc(var(--ring-unit) * 2) calc(-4 * var(--ring-unit)) 0 calc(-4 * var(--ring-unit));
}

.table__e11 {
  --ides-custom-table-header-height: calc(4 * var(--ring-unit));
  position: relative;
}

.table__e11.table__e11 th {
  height: var(--ides-custom-table-header-height);
}

.table__e11 thead::after {
  position: absolute;
  top: calc(var(--ides-custom-table-header-height) - 4px);
  left: calc(4 * var(--ring-unit));
  width: auto;
}

.table__e11.tableAutoWidth__cf6 {
  max-width: 100%;
  width: auto;
}

.table__e11.tableAutoWidth__cf6 th {
  width: auto;
}

.table__e11.tableAutoWidth__cf6 td {
  max-width: fit-content;
  width: auto;
}

.table__e11.tableAutoWidth__cf6 td:last-child {
  padding-right: var(--ring-unit);
}

.table__e11.tableAutoWidth__cf6 td:first-child {
  min-width: auto;
}

.table__e11.tableAutoWidth__cf6 thead::after {
  right: 0;
  min-width: calc(100% - 4 * var(--ring-unit));
}

.table__e11.tableFullWidth__e54 thead::after {
  right: calc(4 * var(--ring-unit));
  min-width: calc(100% - 8 * var(--ring-unit));
}

.table__e11 .tableHoverAction__e16 {
  opacity: 0;
}

.table__e11 tr:hover .tableHoverAction__e16,
.table__e11 tr:focus .tableHoverAction__e16,
.table__e11 tr[data-test-focused='true'] .tableHoverAction__e16 {
  opacity: 1;
}

.table__e11 .tableActionButton__ce5 {
  margin: 0 calc(var(--ring-unit) * 0.85);
}
`, "",{"version":3,"sources":["webpack://./src/common/tables/basic-table-view.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;;;;CAIC;AACD;EACE,4FAA4F;AAC9F;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;EACvD,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":["@value breakpoint-middle from '~@jetbrains/ring-ui/components/global/global.css';\n\n.tableWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ring-unit);\n  padding-bottom: calc(var(--ring-unit) * 3);\n}\n\n/*\nApply negative margins to let table take the full width.\nIt's assumed that table is the first child of the tableWrapper.\nActually table is wrapped by div by default so we have to apply styles to the div element.\n*/\n.tableWrapper > div:nth-child(1) {\n  margin: calc(var(--ring-unit) * 2) calc(-4 * var(--ring-unit)) 0 calc(-4 * var(--ring-unit));\n}\n\n.table {\n  --ides-custom-table-header-height: calc(4 * var(--ring-unit));\n  position: relative;\n}\n\n.table.table th {\n  height: var(--ides-custom-table-header-height);\n}\n\n.table thead::after {\n  position: absolute;\n  top: calc(var(--ides-custom-table-header-height) - 4px);\n  left: calc(4 * var(--ring-unit));\n  width: auto;\n}\n\n.table.tableAutoWidth {\n  max-width: 100%;\n  width: auto;\n}\n\n.table.tableAutoWidth th {\n  width: auto;\n}\n\n.table.tableAutoWidth td {\n  max-width: fit-content;\n  width: auto;\n}\n\n.table.tableAutoWidth td:last-child {\n  padding-right: var(--ring-unit);\n}\n\n.table.tableAutoWidth td:first-child {\n  min-width: auto;\n}\n\n.table.tableAutoWidth thead::after {\n  right: 0;\n  min-width: calc(100% - 4 * var(--ring-unit));\n}\n\n.table.tableFullWidth thead::after {\n  right: calc(4 * var(--ring-unit));\n  min-width: calc(100% - 8 * var(--ring-unit));\n}\n\n.table .tableHoverAction {\n  opacity: 0;\n}\n\n.table tr:hover .tableHoverAction,\n.table tr:focus .tableHoverAction,\n.table tr[data-test-focused='true'] .tableHoverAction {\n  opacity: 1;\n}\n\n.table .tableActionButton {\n  margin: 0 calc(var(--ring-unit) * 0.85);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoint-middle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["breakpoint-middle"]}`,
	"tableWrapper": `tableWrapper__ea9`,
	"table": `table__e11`,
	"tableAutoWidth": `tableAutoWidth__cf6`,
	"tableFullWidth": `tableFullWidth__e54`,
	"tableHoverAction": `tableHoverAction__e16`,
	"tableActionButton": `tableActionButton__ce5`
};
export default ___CSS_LOADER_EXPORT___;
